import { z } from 'zod'
import { optionalText, requiredId, requiredText } from '../../../lib/forms/rules'

/** 24 saat biçimi "HH:mm" — `FormTimeField`'in ürettiği değer. */
const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/

/**
 * Toplantı Kaydı ekle/düzenle şeması.
 *
 * <p>Sınırlar **iş kuralından** gelir (analistin alan listesi): ad 250, açıklama 500 karakter —
 * kolonlar ikisi de `VARCHAR2(1000)`'dir, yani sınır burada gevşetilebilir, DDL gerekmez.
 *
 * <p>**Alanlar arası** iki kural (gelecek tarih yok · bitiş > başlangıç) burada `superRefine` ile
 * uygulanır; sunucu ikisini de bağımsız olarak yeniden uygular — ekran yalnız kullanıcıyı sunucuya
 * gitmeden uyarır, kuralın sahibi sunucudur.
 */
export const meetingRecordFormSchema = z
  .object({
    meetingOrActivityId: requiredId(),
    meetingTypeId: requiredId(),
    name: requiredText(250),
    recordDate: requiredText(),
    startTime: z.string().regex(TIME_RE, { message: 'validation.time' }),
    finishTime: z.string().regex(TIME_RE, { message: 'validation.time' }),
    authorityMandatory: z.boolean(),
    description: optionalText(500),
  })
  .superRefine((v, ctx) => {
    // Gelecek tarih yok: bu ekran OLMUŞ bir zamanı kaydeder, plan değil.
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (v.recordDate && new Date(`${v.recordDate}T00:00:00`) > today) {
      ctx.addIssue({ code: 'custom', path: ['recordDate'], message: 'timePortfolio.errors.futureDate' })
    }
    // Eşitlik de reddedilir: sıfır süreli bir kaydın portföyde anlamı yok.
    if (v.startTime && v.finishTime && v.finishTime <= v.startTime) {
      ctx.addIssue({
        code: 'custom',
        path: ['finishTime'],
        message: 'timePortfolio.errors.finishBeforeStart',
      })
    }
  })

export type MeetingRecordFormValues = z.infer<typeof meetingRecordFormSchema>
